module.exports = __webpack_public_path__ + "img/left.0f0b5688.png";